var divider_viewer_default = {
  "divider-container": "xJEpT",
  "divider-container--double": "RpG9M",
  "divider": "_3P-Ky",
  "divider--single": "FgY4N",
  "divider--double": "HZr6x",
  "divider--dashed": "n8YtF",
  "divider--dotted": "WVnUG",
  "divider--small": "fIzfo",
  "divider--medium": "fEG4r",
  "divider--large": "FN03j",
  "divider--left": "FA1cZ",
  "divider--center": "jgI3e",
  "divider--right": "_9cf5N",
  "svgFixerContainer": "GWbL4",
  "emptyChar": "_1cOIA"
};
export {
  divider_viewer_default as default
};
//# sourceMappingURL=divider-viewer-scss.js.map
